import { render } from "./TermsAcceptanceModal.vue?vue&type=template&id=bb6ae63c&scoped=true"
import script from "./TermsAcceptanceModal.vue?vue&type=script&lang=js"
export * from "./TermsAcceptanceModal.vue?vue&type=script&lang=js"

import "./TermsAcceptanceModal.vue?vue&type=style&index=0&id=bb6ae63c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb6ae63c"]])

export default __exports__